import { useEffect, useMemo } from "react"
import { get } from "lodash"
import { createActions } from "reduxsauce"
import { Creators as ApiCreators } from "model/apiCall"
import { Creators as ResourcesCreators } from "modules/resources/model"
import { useSaveRecentInstrument, getIdAndTypeFromInstrument } from "hooks/use-save-recent-instrument"
import { useDispatch } from "react-redux"
import { useAccountAlias } from "resources/account"

export const { Types, Creators } = createActions({
  updateRecentResources: ["newResource"],
}, {
  prefix: "ompnt/saveRecentResources",
})

export default function saveRecentResources(Component, pathToId, { condition } = {}) {
  const SaveRecentResourcesWrapper = (props) => {
    // We DON'T want the dispatch props, this is a validation for a deprecated requirement
    // eslint-disable-next-line react/prop-types
    if (props.dispatch) {
      console.warn("Unnecessary dispatch provided to saveRecentResources.")
    }

    const dispatch = useDispatch()
    const account = useAccountAlias()

    const resourceId = get(props, pathToId)

    // condition will be removed when Baskets have their own screen as there wont be a component
    // calling different resource types anymore
    let shouldDispatchRecentResources = Boolean(resourceId)
    if (condition && typeof condition === "function" && !condition(props)) {
      shouldDispatchRecentResources = false
    }

    const { modelId, id, assetClass, type, assetId, assetType, assetTickerMic, security, portfolioId } = props ?? {}
    const { saveRecentInstrument } = useSaveRecentInstrument(modelId)
    const { instrumentId, instrumentType } = useMemo(() => {
      const instrumentType = portfolioId ? "portfolio" : type
      return getIdAndTypeFromInstrument({ resourceId, account, id, security, assetClass, type: instrumentType, assetId, assetType, assetTickerMic })
    }, [resourceId, account, id, security, assetClass, type, assetId, assetType, assetTickerMic, portfolioId])

    useEffect(() => {
      if (shouldDispatchRecentResources) {
        const resourcesUrl = `/api/${account}/recent-resources`
        dispatch(ApiCreators.callEndpoint(resourcesUrl, "PUT", { resourceId }, resource => {
          dispatch(ResourcesCreators.updateRecentResources(resource))
          saveRecentInstrument({ instrumentId, instrumentType })
        }))
      } else {
        saveRecentInstrument({ instrumentId, instrumentType })
      }
    }, [dispatch, shouldDispatchRecentResources, account, resourceId, saveRecentInstrument, instrumentId, instrumentType])

    return <Component {...props} />
  }
  SaveRecentResourcesWrapper.displayName = `saveRecentResources(${Component.displayName || Component.name})`
  return SaveRecentResourcesWrapper
}
